import { isEmpty } from 'lodash';
import http from '@/utils/http';

export const postData = (data: any) => {
  if (isEmpty(data)) {
    return null;
  }

  const formData = new FormData();
  const dataName = Object.keys(data);

  dataName.map(name => {
    formData.append(name, data[name]);
    return null;
  });

  return formData;
};

export const uploadFile = (file: File) => {
  const formData = new FormData();
  formData.append('file', file); // 字段名必须与后端参数名一致
  return http.post<API.Common.FileUploadResult>('/common/upload', formData);
};
